import axios from '@/services/axios'
import { getOptions } from '@/services/product'
import * as MutationTypes from './mutation-types'

export const GETPRODUCTLIST = async ({ commit, rootState }, payload) => {
  try {
    commit(MutationTypes.SET_LOADING, true)
    const { page = 1, limit = 35, q = '', sort = '', order = '', instore = '0' } = payload
    const { data: response } = await axios({
      method: 'get',
      url: '/products/private',
      params: {
        page,
        limit,
        q,
        sort,
        order,
        instore,
      },
    })
    const { data } = response

    // count for product not in user store
    let count = 0
    data.map(item => item.in_store === 0 && count++)

    if (page !== 1) {
      const { products, totalProductOutStore } = rootState.product
      const newData = products.concat(data)
      const newCount = totalProductOutStore + count
      commit(MutationTypes.SET_PRODUCT_LIST, newData)
      commit(MutationTypes.SET_TOTAL_PRODUCT_OUT_STORE, newCount)
    } else {
      commit(MutationTypes.SET_PRODUCT_LIST, data)
      commit(MutationTypes.SET_TOTAL_PRODUCT_OUT_STORE, count)
    }

    commit(MutationTypes.SET_TOTAL_PRODUCTS, response.total_row)
    return Promise.resolve()
  } catch (e) {
    console.log(e)
  } finally {
    commit(MutationTypes.SET_LOADING, false)
  }
}

export const ADDPRODUCTTOSTORE = async ({ commit }, payload) => {
  try {
    commit(MutationTypes.SET_LOADING, true)
    const { data: response } = await axios({
      method: 'post',
      url: '/products/private/seller',
      data: {
        ids: payload,
      },
    })
    const { data } = response
    return Promise.resolve(data)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const DELETEFROMSTORE = async ({ commit }, payload) => {
  try {
    commit(MutationTypes.SET_LOADING, true)
    const { data: response } = await axios({
      method: 'delete',
      url: '/products/private/seller',
      data: {
        ids: payload,
      },
    })
    const { data } = response
    return Promise.resolve(data)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const GETPRODUCTINSTORE = async ({ commit, rootState }, payload) => {
  try {
    commit(MutationTypes.SET_LOADING, true)
    const { page = 1, limit = 25, q = '', sort = '', order = '' } = payload
    const { data: response } = await axios({
      method: 'get',
      url: '/products/private/seller',
      params: {
        page,
        limit,
        q,
        sort,
        order,
        channel_id: rootState.user.store_channelid,
      },
    })
    const { data } = response
    if (page !== 1) {
      const { productsInStore } = rootState.product
      const newData = productsInStore.concat(data)
      commit(MutationTypes.SET_PRODUCTS_IN_STORE, newData)
    } else {
      commit(MutationTypes.SET_PRODUCTS_IN_STORE, data)
    }
    commit(MutationTypes.SET_TOTAL_MY_PRODUCTS, response.total_row)
  } catch (err) {
    console.log(err)
  } finally {
    commit(MutationTypes.SET_LOADING, false)
  }
}
const getColorOptions = (catalogues) => Object.keys(getOptions(catalogues, 0))
const getSizeOptions = (catalogues) => Object.keys(getOptions(catalogues, 1))
const getFlavorOptions = (catalogues) => Object.keys(getOptions(catalogues, 2))

export const GETPRODUCTDETAIL = async ({ commit }, payload) => {
  try {
    commit(MutationTypes.SET_LOADING, true)
    const { data: response } = await axios.get(`/products/private/${payload}`)
    const { data } = response
    const product = data
    const colorOptions = getColorOptions(product?.catalog_list || [])
    const sizeOptions = getSizeOptions(product?.catalog_list || [])
    const flavorOptions = getFlavorOptions(product?.catalog_list || [])
    const defaultOptions = {
      color: colorOptions.length ? colorOptions[0] : null,
      size: sizeOptions.length ? sizeOptions[0] : null,
      flavor: flavorOptions.length ? flavorOptions[0] : null,
    }
    commit(MutationTypes.SET_COLOR_OPTIONS, colorOptions)
    commit(MutationTypes.SET_SIZE_OPTIONS, sizeOptions)
    commit(MutationTypes.SET_FLAVOR_OPTIONS, flavorOptions)
    commit(MutationTypes.SET_DEFAULT_OPTIONS, defaultOptions)
    commit(MutationTypes.SET_PRODUCT_DETAIL, product)
    return Promise.resolve(product)
  } catch (err) {
    return Promise.reject(err)
  } finally {
    commit(MutationTypes.SET_LOADING, false)
  }
}
